// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + ({"22":"help","50":"load-game","98":"spectator-home","313":"game-end","412":"player-home","415":"player-input","491":"game-home","492":"games-overview","614":"card-list","646":"start-screen","878":"create-game","884":"admin","966":"login"}[chunkId] || chunkId) + ".js";
};